// @ts-nocheck

/* eslint-disable @typescript-eslint/consistent-type-imports */
import * as React from 'react'
import { SVGProps, memo } from 'react'

const IconInfo = (props: SVGProps<SVGSVGElement> & { slot?: string }) => (
  <svg
    width={4}
    height={15}
    viewBox="0 0 4 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="4" height="4" rx="2" fill="currentColor" />
    <rect y="6" width="4" height="9" rx="2" fill="currentColor" />
  </svg>
)

const Memo = memo(IconInfo)
export default Memo
